import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { Recipe } from '@/shared/types';

interface GenerateState {
  lastRecipes: Recipe[];
  setLastRecipes: (recipes: Recipe[]) => void;
  clearLastRecipes: () => void;
}

export const useGenerateStore = create<GenerateState>()(
  persist(
    (set) => ({
      lastRecipes: [],
      setLastRecipes: (recipes) => set({ lastRecipes: recipes }),
      clearLastRecipes: () => set({ lastRecipes: [] }),
    }),
    {
      name: 'mixly-last-recipes',
    },
  ),
);
